import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import DashboardShell, { StatCard } from "./DashboardShell";
import { Button } from "../../components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function VenueOwnerDashboard() {
  const [venues, setVenues] = useState([]);
  const [bookings, setBookings] = useState([]);

  const load = async () => {
    const [v, b] = await Promise.all([api.get("/my/venues"), api.get("/seller/bookings")]);
    setVenues(v.data); setBookings(b.data);
  };
  useEffect(() => { load(); }, []);

  const revenue = bookings.filter(b => b.payment_status === "paid").reduce((s, b) => s + (b.seller_amount || 0), 0);

  const remove = async (id) => {
    if (!confirm("Supprimer ce lieu ?")) return;
    await api.delete(`/venues/${id}`);
    toast.success("Supprimé"); load();
  };

  return (
    <DashboardShell
      title="Mes lieux"
      subtitle="Gérez vos espaces événementiels et réservations"
      actions={
        <Link to="/dashboard/venues/new">
          <Button data-testid="new-venue-cta" className="bg-ink hover:bg-ink/85 text-cream rounded-none">
            <Plus className="h-4 w-4 mr-2" /> Nouveau lieu
          </Button>
        </Link>
      }
    >
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
        <StatCard label="Lieux publiés" value={venues.length} />
        <StatCard label="Réservations" value={bookings.length} />
        <StatCard label="Confirmées" value={bookings.filter(b => b.payment_status === "paid").length} />
        <StatCard label="Revenus" value={`${revenue.toFixed(0)}€`} accent />
      </div>

      <div className="bg-white border border-ink/10 rounded-md">
        <div className="p-5 border-b border-ink/10">
          <h2 className="font-heading font-medium text-lg text-ink">Mes lieux</h2>
        </div>
        {venues.length === 0 ? (
          <div className="p-12 text-center">
            <p className="text-muted-foreground mb-4">Aucun lieu publié.</p>
            <Link to="/dashboard/venues/new">
              <Button className="bg-ink hover:bg-ink/85 text-cream rounded-none">Publier mon premier lieu</Button>
            </Link>
          </div>
        ) : (
          <div className="divide-y divide-ink/10">
            {venues.map((v) => (
              <div key={v.id} className="p-5 flex justify-between items-center gap-4">
                <div className="flex items-center gap-4 min-w-0">
                  <img src={v.images?.[0] || "https://images.unsplash.com/photo-1772903191730-fa9bc478c1de?w=200"} className="h-16 w-16 rounded-md object-cover" alt="" />
                  <div className="min-w-0">
                    <Link to={`/venues/${v.id}`} className="font-heading font-medium text-ink hover:text-accent truncate block">{v.name}</Link>
                    <p className="text-xs text-muted-foreground">{v.city} · {v.capacity} pers. · {v.price_per_day}€/j</p>
                  </div>
                </div>
                <Button data-testid={`delete-venue-${v.id}`} variant="ghost" size="sm" onClick={() => remove(v.id)}>
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}
